import queryString from 'query-string';
import React, { Component } from "react";
import { Button, ButtonToolbar, Modal } from "react-bootstrap";
import Alert from 'react-s-alert';
import AuthContext from '../auth-context';
import ConfirmButton from '../Shared/ConfirmButton';
import LeadsService from '../utils/LeadsService';
import AddNoteModal from './AddNoteModal';
import EditModal from './EditModal';

class ButtonBar extends Component {
  static contextType = AuthContext;

  state = {}

  handleConfirmModal = (response) => {
    this.closeModals()
    if (this.props.handleLeadUpdated) this.props.handleLeadUpdated(response.lead)
  }

  closeModals = () => {
    this.setState({ showModalConfirm: false, showModalNotPresented: false })
  }

  bookTCS = () => {
    this.setState({ showModalNeedRefresh: true })
    const { lead } = this.props
    const authStore = this.context
    const profile = authStore.profile
    const data = {
      email: lead.email,
      first_name: lead.first_name,
      mobile: lead.mobile,
      region: lead.region,
      student_first_name: lead.student_first_name,
      lead_id: lead.id,
      m1_booking_user: profile.email,
      booking_from: lead.booking_from,
      business_stream: lead.business_stream,
      redirect_url: window.location,
    }
    const params = queryString.stringify(data)
    const url = `${process.env.REACT_APP_BOOKING_URL}?${params}`
    window.open(url, "_blank")
  }

  bookSeminarRegistration = (from) => {
    this.setState({ showModalNeedRefresh: true })
    const { lead } = this.props
    const authStore = this.context
    const profile = authStore.profile
    const data = {
      email: lead.email,
      first_name: lead.first_name,
      mobile: lead.mobile,
      region: lead.region,
      student_first_name: lead.student_first_name,
      lead_id: lead.id,
      m1_booking_user: profile.email,
      booking_from: lead.booking_from,
      business_stream: lead.business_stream,
      redirect_url: window.location
    }
    const params = queryString.stringify(data)

    const url = `${process.env.REACT_APP_SREG_URL}?${params}`
    window.open(url, "_blank")
  }

  markCompleted = (note) => {
    LeadsService.takeAction('mark_completed', this.props.lead.id, { note: note })
      .then(response => {
        Alert.success('Completed')
        this.props.handleLeadUpdated(response.lead)
      });
  }

  closeModals = () => {
    this.setState({ showModalAddNote: false, showModalEdit: false, showModalNeedRefresh: false })
  }

  render() {
    const { lead, reloadLead } = this.props

    return (
      <div style={{ marginTop: 6 }}>
        <ButtonToolbar>
          {!lead.flags.includes('completed') && <Button style={{ marginBottom: 2, marginRight: 10 }} bsStyle='info'
            bsSize="xsmall"
            onClick={() => this.bookSeminarRegistration()}
          >Book a Seminar</Button>}

          {!lead.flags.includes('completed') && <Button style={{ marginBottom: 2, marginRight: 10 }} bsStyle='info'
            bsSize="xsmall"
            onClick={() => this.bookTCS()}
          >Book a Trial Coaching Session</Button>}

          {<Button style={{ marginBottom: 2, marginRight: 10 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalAddNote: true })}>Add Note</Button>}
          {!lead.flags.includes('completed') && <Button style={{ marginBottom: 2, marginRight: 10 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalEdit: true })}>Edit Lead</Button>}
          {!lead.flags.includes('completed') && <ConfirmButton bsStyle='warning' text='Mark Complete' okAction={(note) => this.markCompleted(note)} />}
        </ButtonToolbar>

        <AddNoteModal showModal={this.state.showModalAddNote} lead={lead} onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />
        <EditModal showModal={this.state.showModalEdit} lead={lead} onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />

        <Modal show={this.state.showModalNeedRefresh} onHide={() => reloadLead() & this.closeModals()} bsSize="large">
          <Modal.Header closeButton>
            <Modal.Title>Updating Coaching Session</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>After you have booked or rescheduled, the follow up will need to be reloaded</p>
            <div>
              <Button bsStyle='success' bsSize='small' onClick={() => reloadLead() & this.closeModals()}>Reload Now</Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default ButtonBar